import YYAvatar from './avatar.vue'
export default YYAvatar
